// AML Data Types
export type RiskLevel = "LowRisk" | "HighRisk" | "RiskWithLimit";

export interface SourceOfPropertyItem {
    Id: number;
    Name: string;
    StarpensionName: string;
    InfoRequired: boolean;
}

export interface OtherIncomeItem {
    Id: number;
    Job: string;
    Risk: RiskLevel;
    InfoRequired: boolean;
}

export interface BusinessIncomeItem {
    Id: number;
    Job: string;
    Risk: RiskLevel;
    InfoRequired: boolean;
}

export interface AverageIncomeItem {
    Id: number;
    Name: string;
    Min: number;
    Max: number;
}

export interface CountryItem {
    country_code: string;
    country_code_a3: string;
    country_code_n3: string;
    country_name: string;
    country_name_long: string;
    country_name_cz: string;
    country_name_cz_long: string;
    country_name_sk: string;
    country_name_sk_long: string;
    batch_id: number;
    risk_country?: boolean;
}

// Data exports
import AverageIncomeData from "./AverageIncome.json";
import BusinessIncomeData from "./BusinessIncome.json";
import CountriesData from "./countries.json";
import OtherIncomeData from "./OtherIncome.json";
import SourceOfPropertyData from "./SourceOfProperty.json";

export const SourceOfProperty = SourceOfPropertyData as SourceOfPropertyItem[];
export const OtherIncome = OtherIncomeData as OtherIncomeItem[];
export const BusinessIncome = BusinessIncomeData as BusinessIncomeItem[];
export const AverageIncome = AverageIncomeData as AverageIncomeItem[];
export const Countries = CountriesData as CountryItem[];

// Default exports for backward compatibility
export { AverageIncomeData, BusinessIncomeData, CountriesData, OtherIncomeData, SourceOfPropertyData };
